import Cookie from 'js-cookie'

import { getCookie, setCookie } from '@flowwai-frontend/shared/utils/web'

export const REFRESH_TOKEN_KEY = 'refresh_token'
export const ACCESS_TOKEN = 'access_token'
export function getRefreshToken() {
   return getCookie(REFRESH_TOKEN_KEY)
}
export function setRefreshToken(refreshToken: string, expiryInDays = 30) {
   setCookie(REFRESH_TOKEN_KEY, refreshToken, expiryInDays)
}

export function getAccessToken() {
   return getCookie(ACCESS_TOKEN)
}
